import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

import { ApiContext } from '../context/ApiContext';
import useAuth from '../hooks/useAuth';
const Login = () => {
    const apiUrl = useContext(ApiContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();

    const navigate = useNavigate();
    const handleLogin = async () => {
        try {
            await login(email, password);
            // apiCall handles setting isLoggedIn=true on success
            navigate('/posts');
        } catch (error) {
            if (error.message.includes('409')) {
                // Handle first-time login requiring activation
                const activationUrl = apiUrl ? `${apiUrl}/api/v1/user-activation/request` : '/api/v1/user-activation/request';
                try {
                    const response = await fetch(activationUrl, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Client-Type': 'web'
                        },
                        body: JSON.stringify({ email })
                    });
                    
                    if (response.ok) {
                        navigate(`/user-activation/verify?email=${encodeURIComponent(email)}`);
                    } else {
                        alert('Failed to login first time. Try again later. Or request password reset.');
                    }
                } catch (activationError) {
                    console.error('Error during activation request:', activationError);
                    alert('An error occurred during activation. Please try again.');
                }
            } else {
                alert(error.message || 'Login Failed!');
            }
        }
    };

    return (
        <div className="Login">
            <h2>Login</h2>
            <form>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="username"
                        name="username"
                        id="username"
                    />
                </div>
                <div>
                    <label>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                        name="current-password"
                        id="current-password"
                    />
                </div>
                <div>
                    <div className="forgot-password-container">
                        <a href="/reset-password" className="forgot-password-link">Forgot Password?</a>
                    </div>
                </div>
                <div className="form-buttons">
                    <button type="button" onClick={() => window.history.back()}>Cancel</button>
                    <button type="button" onClick={handleLogin}>Login</button>
                </div>
            </form>
        </div>
    );
};

export default Login;
